import './HelpNavDesktop.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Sticky } from 'semantic-ui-react';
import { defaultTo } from 'lodash';

import HelpNodeBrowser from 'components/help/nav/topicNodes/HelpNodeBrowser';
import ContactUsNode from 'components/help/nav/topicNodes/ContactUsNode';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('help')
class HelpNavDesktopContainer extends React.Component {
  render() {
    return <HelpNavDesktop {...this.props} />;
  }
}

class HelpNavDesktop extends React.Component {
  static propTypes = {
    contentHeight: PropTypes.number.isRequired,
    contextRef: PropTypes.object,
    navHeight: PropTypes.number.isRequired,
    nodeHierarchy: PropTypes.array.isRequired,
    onHeightUpdate: PropTypes.func.isRequired,
    selectedNodeId: PropTypes.string,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static constants = {
    MARGIN_FROM_TOP_OF_BROWSER: 40,
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.isStickyEnabled = this.isStickyEnabled.bind(this);
  }

  isStickyEnabled() {
    const { contentHeight, navHeight } = this.props;
    return contentHeight > navHeight + HelpNavDesktop.constants.MARGIN_FROM_TOP_OF_BROWSER;
  }

  render() {
    const { getString } = this.context;

    return (
      <Sticky
        context={this.props.contextRef}
        active={this.isStickyEnabled()}
        offset={HelpNavDesktop.constants.MARGIN_FROM_TOP_OF_BROWSER}
      >
        <div className="aa-help-nav-desktop">
          <Grid divided="vertically">
            <Grid.Row>
              <div className="aa-help-nav-desktop__title">
                { defaultTo(getString('AA_Help_Navigation_Title'), '').toUpperCase() }
              </div>
            </Grid.Row>
            <Grid.Row>
              <div className="aa-help-nav-desktop__hierarchy">
                <HelpNodeBrowser
                  nodeHierarchy={this.props.nodeHierarchy}
                  selectedNodeId={this.props.selectedNodeId}
                  onExpand={this.props.onHeightUpdate}
                />
                <ContactUsNode title={getString('AA_Contact_Us')} />
              </div>
            </Grid.Row>
          </Grid>
        </div>
      </Sticky>
    );
  }
}

export default HelpNavDesktopContainer;
